var render = function render(_c, _vm) {
  return _c(
    "div",
    [
      _c("icon-view", {
        staticClass: "mb-3",
        attrs: {
          icon: "fa fa-file-alt",
          "icon-background": "#FF7058",
          "icon-color": "#fff",
          title: "Información de Estatus Voucher y Pago"
        }
      }),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col ml-2" }, [
          _c(
            "div",
            { staticClass: "color-gray-6 font-14 font-weight-normal" },
            [_vm._v(" Payment Count: ")]
          ),
          _c("div", { staticClass: "color-black font-16 font-weight-normal" }, [
            _vm._v(" " + _vm._s(_vm.props.info.paymentCount) + " ")
          ])
        ]),
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            { staticClass: "color-gray-6 font-14 font-weight-normal" },
            [_vm._v(" Payment ID: ")]
          ),
          _c("div", { staticClass: "color-black font-16 font-weight-normal" }, [
            _vm._v(
              " " + _vm._s(_vm._f("empty")(_vm.props.info.paymentId)) + " "
            )
          ])
        ]),
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            { staticClass: "color-gray-6 font-14 font-weight-normal" },
            [_vm._v(" Budget Check Status: ")]
          ),
          _c("div", { staticClass: "color-black font-16 font-weight-normal" }, [
            _vm._v(
              " " +
                _vm._s(_vm._f("empty")(_vm.props.info.budgetCheckStatus)) +
                " "
            )
          ])
        ]),
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            { staticClass: "color-gray-6 font-14 font-weight-normal" },
            [_vm._v(" Payment Status: ")]
          ),
          _c("div", { staticClass: "color-black font-16 font-weight-normal" }, [
            _vm._v(
              " " + _vm._s(_vm._f("empty")(_vm.props.info.paymentStatus)) + " "
            )
          ])
        ]),
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            { staticClass: "color-gray-6 font-14 font-weight-normal" },
            [_vm._v(" Payment Process Date: ")]
          ),
          _c("div", { staticClass: "color-black font-16 font-weight-normal" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm._f("empty")(
                    _vm._f("date")(_vm.props.info.paymentProcessDate)
                  )
                ) +
                " "
            )
          ])
        ]),
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            { staticClass: "color-gray-6 font-14 font-weight-normal" },
            [_vm._v(" Cash Cleared Date: ")]
          ),
          _c("div", { staticClass: "color-black font-16 font-weight-normal" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm._f("empty")(
                    _vm._f("date")(_vm.props.info.cashClearedDate)
                  )
                ) +
                " "
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }